import React, { useState } from 'react';
import "../components/Styles/Project2.css";

const projects = [
    {
    title: '  Rails cape Maintenance robot',
    img: '/img/indprojects/ind23/ind23-1.jpg',
    description: 'An autonomous robot designed for real-time railway track monitoring and maintenance. It uses ultrasonic, IR, and PIR sensors to detect cracks, obstacles, and unauthorized access. A robotic arm removes debris, while temperature sensors prevent issues like rail buckling. The robot also performs cleaning and painting tasks, reducing manual labor. With GPS and Wi-Fi, it streams live data to a control center without disrupting train operations.  ',
  },
    {
    title: 'Multipurpose agricultural bot  ',
    img: '/img/indprojects/ind23/ind23-1.jpg',
    description: 'Farmers face challenges in efficiently performing tasks like ploughing, planting, watering, and spraying insecticides, often leading to increased labour and costs. There is a need for an affordable, multipurpose agricultural robot that can automate these tasks. The robot should integrate sensors for precision, be easy to control, and adaptable to different farming conditions, ultimately improving productivity and reducing manual effort. ',
  },
    {
    title: ' Guardian ',
    img: '/img/indprojects/ind23/ind23-1.jpg',
    description: 'Guardians is an autonomous ground robot designed to assist in disaster-stricken areas by locating survivors, avoiding hazards, and transmitting real-time data. It aims to reduce human risk and accelerate rescue operations using smart navigation, sensors, and AI.  ',
  },
    {
    title: ' Mining Inspection and Monitoring Robot  ',
    img: '/img/indprojects/ind23/ind23-1.jpg',
    description: 'This semi-autonomous ground robot is built to inspect underground mines post-blasting or drilling. It detects hazards like toxic gases, debris, and structural risks. Using LoRa communication, it transmits real-time data to surface operators without requiring human entry into dangerous areas, enhancing safety during post-mining operations.  ',
  },
    {
    title: ' Vayu Stambha Niriksana Yantra',
    img: '/img/indprojects/ind23/ind23-1.jpg',
    description: 'This project aims to develop a robotic system for inspecting and maintaining offshore wind poles, reducing human risk and operational costs. Using high-definition cameras, ultrasonic sensors, and a rope-based climbing mechanism powered by servo and high-torque motors, the robot ensures real-time monitoring, efficient mobility, and targeted maintenance, enhancing the reliability of wind energy infrastructure. ',
  },
    {
    title: 'Crop Protection Bot  ',
    img: '/img/indprojects/ind23/ind23-1.jpg',
    description: 'Farmers face crop losses due to wild animals like elephants, deer, and birds, leading to financial strain and food insecurity. To address this, we propose an autonomous Crop Protection Bot using an ESP32 microcontroller. A PIR sensor (HC SR505) detects motion, triggering a buzzer and LED to deter animals. An ESP32-CAM captures images for analysis. A servo motor (SG90), controlled by an Arduino Nano, enables precise field monitoring. The system is autonomous, energy-efficient, and operates in real-time, reducing the need for manual supervision. It offers a cost-effective, tech-based solution to safeguard crops and support sustainable agriculture. ',
  },
    {
    title: 'Smart Traffic System  ',
    img: '/img/indprojects/ind23/ind23-1.jpg',
    description: 'The project aims to implement a dynamic traffic control system using real-time traffic density data from ultrasonic sensors to adjust signal timings and reduce congestion. It also includes an ambulance priority feature using ESP32 microcontrollers and ESP cameras to detect approaching ambulances and automatically provide a green corridor for their swift movement through intersections.',
  },
    {
    title: 'WallAce',
    img: '/img/indprojects/ind23/ind23-1.jpg',
    description: 'WallAce is a semi-autonomous bot designed to paint the exteriors of tall buildings safely and efficiently. Traditional methods are risky and labor-intensive. WallAce addresses this with two coordinated units—one moving vertically (Y-axis) and the other horizontally (X-axis)—controlled wirelessly via ESP32 microcontrollers using ESP-NOW. It features a paint roller, servo mechanisms, a rack and pinion system, and sensors to ensure smooth and uniform paint application.  ',
  },
    {
    title: 'Semiautonomous Salt Extraction Bot ',
    img: '/img/indprojects/ind23/ind23-1.jpg',
    description: 'This project introduces a semiautonomous robot designed to extract salt from seawater with minimal human involvement. The bot navigates coastal areas, collects seawater, and uses energy-efficient desalination methods such as controlled evaporation or membrane filtration. Equipped with salinity sensors, it operates in a selfsustained manner, making it especially suitable for remote coastal and island communities.  ',
  },
    {
    title: ' Manhole Inspection and Debris Removal Robot',
    img: '/img/indprojects/ind23/ind23-1.jpg',
    description: 'Manhole Inspection and Debris Removal Robot focuses on creating an automated robot to inspect and clean manholes, reducing the need for manual labor in hazardous environments. Equipped with gas sensors, wheels for mobility, motor drivers, and debris collection tools, the robot will autonomously navigate manholes, detect blockages, and remove waste. An Arduino Mega microcontroller handles control and decision-making, ensuring real-time monitoring and adaptive movement.',
  },
    {
    title: ' UV Sanitization Robot  ',
    img: '/img/indprojects/ind23/ind23-1.jpg',
    description: 'This robot automates hospital room disinfection using germicidal UV rays that destroy microorganisms by disrupting their DNA. Operated via Wi-Fi, it navigates autonomously using a radarbased system and streams live video for real-time monitoring. Ideal for high-risk areas like ICUs and isolation wards, it minimizes human contact and reduces infection risk.',
  },
    {
    title: 'HYDRONOX  ',
    img: '/img/indprojects/ind23/ind23-1.jpg',
    description: 'HYDRONOX is a semi-autonomous underwater robot designed for rescue and research. Powered by an ESP32- CAM, it enables live video monitoring and object detection. It uses waterproof motors and a servo-controlled gripper to navigate and interact with underwater environments. Controlled via the Blynk app, it performs safely in hazardous aquatic zones.',
  },
    
];

function Post24() {
  const [popupData, setPopupData] = useState(null);

  const openPopup = (project) => {
    setPopupData(project);
  };

  const closePopup = () => {
    setPopupData(null);
  };

  return (
    <>
    <div className="header">
      <h1 className="head-title">Post Induction 2024</h1>
    </div>
    <div className="projects-wrapper">
      <div className="projects-grid">
        {projects.map((project, index) => (
          <div
            key={index}
            className="project-card"
            onClick={() => openPopup(project)}
          >
            <div className="project-img">
              <img src={project.img} alt={project.title} />
            </div>
            <div className="project-title">{project.title}</div>
          </div>
        ))}
      </div>

      {popupData && (
        <div className="popup" style={{ display: 'flex' }}>
          <div className="popup-content">
            <span className="close-btn" onClick={closePopup}>×</span>
            <img src={popupData.img} alt="Popup" />
            <h5>{popupData.title}</h5>
            <p>{popupData.description}</p>
          </div>
        </div>
      )}
    </div>
    </>
  );
}

export default Post24;